const AboutUs = () => {
  return (
    <div
      className="container d-flex flex-column align-items-center"
      style={{ marginTop: "8em", marginBottom: "6em" }}
    >
      <h1 className="display-4 text-uppercase mb-5">About us</h1>
      <p className="text-center h4">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia quo
        quod impedit aperiam? Vitae enim, asperiores tempora sit soluta saepe
        consequuntur est omnis nihil provident nulla atque magnam nostrum quos
        sequi non quibusdam ipsum modi mollitia cupiditate porro corporis nam.
      </p>
    </div>
  );
};

export default AboutUs;
